function r(a) {
  return a.name === "NavigationDuplicated" ||
  // compatible with vue-router@3.3
  a.message && a.message.indexOf("redundant navigation") !== -1;
}
function c(a, t) {
  var o = t.to,
    n = t.url,
    u = t.replace;
  if (o && a) {
    var e = a[u ? "replace" : "push"](o);
    e && e.catch && e.catch(function (i) {
      if (i && !r(i)) throw i;
    });
  } else n && (u ? location.replace(n) : location.href = n);
}
function l(a) {
  c(a.parent && a.parent.$router, a.props);
}
var p = {
  url: String,
  replace: Boolean,
  to: [String, Object]
};
export { l as functionalRoute, c as route, p as routeProps };
